export default __webpack_public_path__ + "static/media/elo.a798236d.svg";